/**
 * Product Configurator — cascading metafield filters + variant selectors
 *
 * Data shape (same as collection-configurator):
 *   metafilterBlocks: [{ key: "custom.depth", label: "Shelf Depth" }, ...]
 *   products[]: { metafields: { "custom.depth": "18\"", ... }, options, variants }
 *
 * Cascade: metafield_filter[0] → [1] → ... → [N] → variant_option[0] → ... → resolve variant
 *
 * Products are sourced from template blocks (not a collection).
 */
(function() {
  var data, metafieldSelects, optionSelects, resultEl, noMatchEl;

  function init() {
    var el = document.getElementById('configurator-data');
    if (!el) return;
    try { data = JSON.parse(el.textContent); } catch(e) { return; }

    // Collect metafield filter selects in DOM order
    metafieldSelects = [];
    var mfEls = document.querySelectorAll('.cfg-metafield-select');
    mfEls.forEach(function(sel) {
      metafieldSelects.push({
        el: sel,
        key: sel.getAttribute('data-metafield-key')
      });
      sel.addEventListener('change', onMetafieldChange);
    });

    optionSelects = document.querySelectorAll('.cfg-option-select');
    resultEl = document.getElementById('cfg-result');
    noMatchEl = document.getElementById('cfg-no-match');

    if (metafieldSelects.length === 0 && optionSelects.length === 0) return;

    // If there are metafield filters, populate the first one
    if (metafieldSelects.length > 0) {
      populateMetafieldSelect(0, data.products);
      metafieldSelects[0].el.disabled = false;
      // Auto-cascade if only one value
      if (metafieldSelects[0].el.value) {
        onMetafieldChange.call(metafieldSelects[0].el);
      }
    } else {
      // No metafield filters — go straight to variant options
      onAllMetafieldsSelected(data.products);
    }

    optionSelects.forEach(function(sel) {
      sel.addEventListener('change', onOptionChange);
    });

    // ATC form
    var form = document.getElementById('cfg-result-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        addToCart(this);
      });
    }
  }

  // --- Helpers ---

  function unique(arr) {
    var seen = {};
    return arr.filter(function(v) {
      if (v == null || v === '') return false;
      var s = String(v);
      if (seen[s]) return false;
      seen[s] = true;
      return true;
    });
  }

  function numericSort(a, b) {
    var na = parseFloat(a) || 0;
    var nb = parseFloat(b) || 0;
    if (na !== nb) return na - nb;
    return String(a).localeCompare(String(b));
  }

  function populateSelect(sel, values, placeholder, keepValue) {
    var prev = keepValue ? sel.value : '';
    sel.innerHTML = '';
    if (placeholder) {
      var opt = document.createElement('option');
      opt.value = '';
      opt.textContent = placeholder;
      sel.appendChild(opt);
    }
    values.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      sel.appendChild(opt);
    });
    sel.disabled = false;
    if (prev && values.indexOf(prev) !== -1) {
      sel.value = prev;
    } else if (values.length === 1) {
      sel.value = values[0];
    }
  }

  // --- Metafield cascade ---

  /** Get products matching all metafield filters from index 0 to upToIndex-1 */
  function getFilteredProducts(upToIndex) {
    var products = data.products;
    for (var i = 0; i < upToIndex && i < metafieldSelects.length; i++) {
      var key = metafieldSelects[i].key;
      var val = metafieldSelects[i].el.value;
      if (!val) break;
      products = products.filter(function(p) {
        return String(p.metafields[key]) === val;
      });
    }
    return products;
  }

  /** Populate metafield select at given index with values from filtered product set */
  function populateMetafieldSelect(index, products) {
    var mf = metafieldSelects[index];
    var key = mf.key;
    var values = unique(products.map(function(p) { return p.metafields[key]; }).filter(Boolean));
    values.sort(numericSort);
    populateSelect(mf.el, values, values.length > 1 ? 'Select...' : null);
    if (values.length === 1) mf.el.value = values[0];
  }

  function onMetafieldChange() {
    hideResult();

    // Find which filter changed
    var changedIndex = -1;
    for (var i = 0; i < metafieldSelects.length; i++) {
      if (metafieldSelects[i].el === this) { changedIndex = i; break; }
    }
    if (changedIndex === -1) return;

    // Reset all downstream metafield selects
    for (var i = changedIndex + 1; i < metafieldSelects.length; i++) {
      var prevLabel = metafieldSelects[changedIndex].el.closest('.configurator__field').querySelector('.configurator__label');
      var hint = prevLabel ? prevLabel.textContent.toLowerCase() : 'above';
      metafieldSelects[i].el.innerHTML = '<option value="">Select ' + hint + ' first</option>';
      metafieldSelects[i].el.disabled = true;
    }

    // Reset variant option selects
    disableOptionSelects();

    if (!this.value) return;

    // Products matching all selections up to and including this one
    var filtered = getFilteredProducts(changedIndex + 1);

    if (changedIndex + 1 < metafieldSelects.length) {
      // More metafield filters to populate
      populateMetafieldSelect(changedIndex + 1, filtered);
      // Auto-cascade if only one value
      if (metafieldSelects[changedIndex + 1].el.value) {
        onMetafieldChange.call(metafieldSelects[changedIndex + 1].el);
      }
    } else {
      // All metafield filters are set — move to variant options
      onAllMetafieldsSelected(filtered);
    }
  }

  function onAllMetafieldsSelected(filteredProducts) {
    var product = filteredProducts[0];
    if (!product) { disableOptionSelects(); return; }

    // Populate each variant option select
    optionSelects.forEach(function(sel) {
      var optName = sel.getAttribute('data-option-name');
      var optDef = product.options.find(function(o) { return o.name === optName; });
      if (optDef && optDef.values && optDef.values.length > 0) {
        var vals = optDef.values.slice();
        vals.sort(numericSort);
        populateSelect(sel, vals, vals.length > 1 ? 'Select...' : null, true);
        if (vals.length === 1) sel.value = vals[0];
      } else {
        sel.innerHTML = '<option value="">N/A</option>';
        sel.disabled = true;
      }
    });

    resolveVariant();
  }

  // --- Variant option cascade ---

  function onOptionChange() {
    var filtered = getFilteredProducts(metafieldSelects.length);
    var product = filtered[0];
    if (!product) return;

    // Build selected options and cascade-filter downstream options
    var priorSelections = {};
    optionSelects.forEach(function(sel) {
      var optName = sel.getAttribute('data-option-name');
      var optDef = product.options.find(function(o) { return o.name === optName; });
      if (!optDef) return;

      var optIndex = product.options.indexOf(optDef);

      // Filter variants by all prior selections
      var compatibleVariants = product.variants.filter(function(v) {
        for (var name in priorSelections) {
          var idx = product.options.findIndex(function(o) { return o.name === name; });
          if (idx !== -1 && v.options[idx] !== priorSelections[name]) return false;
        }
        return true;
      });

      var availableValues = unique(compatibleVariants.map(function(v) { return v.options[optIndex]; }));
      availableValues.sort(numericSort);

      var currentVal = sel.value;
      populateSelect(sel, availableValues, availableValues.length > 1 ? 'Select...' : null);
      if (currentVal && availableValues.indexOf(currentVal) !== -1) {
        sel.value = currentVal;
      } else if (availableValues.length === 1) {
        sel.value = availableValues[0];
      }

      if (sel.value) {
        priorSelections[optName] = sel.value;
      }
    });

    resolveVariant();
  }

  // --- Resolve final variant ---

  function resolveVariant() {
    // Check all metafield filters have values
    for (var i = 0; i < metafieldSelects.length; i++) {
      if (!metafieldSelects[i].el.value) { hideResult(); return; }
    }

    var filtered = getFilteredProducts(metafieldSelects.length);
    var product = filtered[0];
    if (!product) { hideResult(); return; }

    // Check all variant option selects have values
    var selectedOpts = {};
    var allSelected = true;
    optionSelects.forEach(function(sel) {
      var name = sel.getAttribute('data-option-name');
      if (sel.value) {
        selectedOpts[name] = sel.value;
      } else {
        allSelected = false;
      }
    });

    if (!allSelected) { hideResult(); return; }

    // Find matching variant
    var variant = product.variants.find(function(v) {
      for (var name in selectedOpts) {
        var idx = product.options.findIndex(function(o) { return o.name === name; });
        if (idx !== -1 && v.options[idx] !== selectedOpts[name]) return false;
      }
      return true;
    });

    if (variant) {
      showResult(product, variant);
    } else {
      resultEl.style.display = 'none';
      noMatchEl.style.display = 'block';
    }
  }

  // --- UI helpers ---

  function showResult(product, variant) {
    noMatchEl.style.display = 'none';

    var img = document.getElementById('cfg-result-image');
    img.src = variant.image;
    img.alt = product.title;

    var link = document.getElementById('cfg-result-link');
    link.href = product.url;

    var titleLink = document.getElementById('cfg-result-title-link');
    titleLink.href = product.url;
    titleLink.textContent = product.title;

    var model = document.getElementById('cfg-result-model');
    model.textContent = variant.title;

    var price = document.getElementById('cfg-result-price');
    price.textContent = variant.price;

    var stock = document.getElementById('cfg-result-stock');
    stock.textContent = variant.available ? 'IN STOCK' : 'Out of Stock';
    stock.className = variant.available
      ? 'size-card__badge size-card__badge--stock'
      : 'size-card__badge size-card__badge--oos';

    var btn = document.getElementById('cfg-result-btn');
    btn.setAttribute('data-variant-id', variant.id);
    btn.disabled = !variant.available;
    btn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

    var pdpLink = document.getElementById('cfg-result-pdp-link');
    pdpLink.href = product.url;

    resultEl.style.display = 'block';

    loadRecommendations(product.id);
  }

  // --- Product Recommendations ---

  var lastRecsProductId = null;

  function loadRecommendations(productId) {
    var container = document.getElementById('cfg-recommendations');
    var grid = container ? container.querySelector('.cfg-recs__grid') : null;
    if (!container || !grid) return;

    // Don't re-fetch if same product
    if (lastRecsProductId === productId) {
      container.style.display = '';
      return;
    }
    lastRecsProductId = productId;

    grid.innerHTML = '<div class="cfg-recs__loading">Loading recommendations...</div>';
    container.style.display = '';

    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function(res) { return res.json(); })
      .then(function(data) {
        var products = data.products || [];
        if (products.length === 0) {
          container.style.display = 'none';
          return;
        }
        grid.innerHTML = '';
        products.forEach(function(rec) {
          var v = rec.variants[0];
          if (!v) return;

          var card = document.createElement('div');
          card.className = 'cfg-recs__card';

          var imgUrl = rec.featured_image
            ? rec.featured_image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2')
            : '';

          var priceHtml = '<span class="cfg-recs__price">' + formatMoney(v.price) + '</span>';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            priceHtml += '<span class="cfg-recs__compare-price">' + formatMoney(v.compare_at_price) + '</span>';
          }

          card.innerHTML =
            '<a href="' + rec.url + '" class="cfg-recs__card-img">' +
              '<img src="' + imgUrl + '" alt="' + escapeHtml(rec.title) + '" loading="lazy" width="160" height="160">' +
            '</a>' +
            '<div class="cfg-recs__card-info">' +
              '<a href="' + rec.url + '" class="cfg-recs__card-title">' + escapeHtml(rec.title) + '</a>' +
              '<div class="cfg-recs__card-price">' + priceHtml + '</div>' +
            '</div>' +
            '<button type="button" class="cfg-recs__card-atc" data-variant-id="' + v.id + '"' +
              (v.available ? '' : ' disabled') + '>' +
              (v.available ? 'Add to Cart' : 'Sold Out') +
            '</button>';

          var atcBtn = card.querySelector('.cfg-recs__card-atc');
          atcBtn.addEventListener('click', function() { addRecToCart(this); });
          grid.appendChild(card);
        });
      })
      .catch(function() {
        container.style.display = 'none';
      });
  }

  function hideRecommendations() {
    var container = document.getElementById('cfg-recommendations');
    if (container) container.style.display = 'none';
    lastRecsProductId = null;
  }

  function addRecToCart(btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function() {
      btn.textContent = 'Added!';
      btn.classList.add('cfg-recs__card-atc--success');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('cfg-recs__card-atc--success');
      }, 1500);
      btn.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: btn, quantity: 1 }
      }));
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function hideResult() {
    if (resultEl) resultEl.style.display = 'none';
    if (noMatchEl) noMatchEl.style.display = 'none';
    hideRecommendations();
  }

  function disableOptionSelects() {
    optionSelects.forEach(function(sel) {
      sel.innerHTML = '<option value="">Make selections above</option>';
      sel.disabled = true;
    });
  }

  function addToCart(form) {
    var btn = form.querySelector('.configurator__atc-btn');
    var variantId = btn.getAttribute('data-variant-id');
    var qty = parseInt(form.querySelector('.configurator__atc-qty').value) || 1;
    if (!variantId || btn.disabled) return;

    btn.disabled = true;
    var originalText = btn.textContent;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function() {
      btn.textContent = 'Added!';
      btn.classList.add('configurator__atc-btn--success');
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
        btn.classList.remove('configurator__atc-btn--success');
      }, 1500);
      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: { button: btn, quantity: qty }
      }));
    })
    .catch(function() {
      btn.textContent = 'Error';
      setTimeout(function() {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1500);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
